import {none, option, Option} from "ts-option";
import JobProfit from "./JobProfit";
import Price from "../common/Price";
import {BomApiDto} from "../../api/model/rest";
import {BomItems} from "./BomItems";

export class Bom {
	constructor(
		public readonly id: string,
		public readonly items: BomItems,
		public readonly profit: JobProfit,
		public readonly total: Option<Price>,
		public readonly customerPrice: Price,
		public readonly installerEarnings: Option<Price>,
		public readonly customerPriceDifference: Option<Price>,
		public readonly merchantId: string,
		public readonly merchantBranchLocation: Option<string>,
		public readonly partsPriceStrategy: string) {}

	static fromJson(json: BomApiDto): Bom {
		const items = BomItems.fromJson(json.items)
		const total = json.total ? option(Price.fromJson(json.total)) : none;
		const customerPrice = Price.fromJson(json.customerPrice)
		const installerEarnings = json.installerEarnings ? option(Price.fromJson(json.installerEarnings)) : none;
		const customerPriceDifference = json.customerPriceDifference ? option(Price.fromJson(json.customerPriceDifference)) :
			none;
		return new Bom(json.id, items, JobProfit.fromJson(json.profit), total, customerPrice, installerEarnings,
			customerPriceDifference, json.merchantId, option(json.merchantBranchLocation), json.partsPriceStrategy);
	}
}
